<template>
  <sovi-dialog :show="model" @close="model = false">
    <div class="place-center mt-6 grid p-4">
      <div
        class="sovi-status-dialog__wrapper mx-auto grid w-full grid-cols-[auto_auto] items-center justify-start gap-4"
        :class="{ [type]: true }"
      >
        <svg class="checkmark" viewBox="0 0 52 52">
          <circle
            class="checkmark__circle"
            cx="26"
            cy="26"
            r="25"
            fill="none"
          />

          <path class="checkmark__check" fill="none" :d="iconPath" />
        </svg>

        <div class="grid">
          <p
            class="animate-fade-right text-lg font-semibold text-black/60 animate-delay-500 animate-duration-300 animate-ease-out dark:text-white/65"
          >
            {{ title }}
          </p>

          <p
            v-if="subtitle"
            class="animate-fade-right text-sm text-black/60 animate-delay-[700ms] animate-duration-300 animate-ease-out dark:text-white/65"
          >
            {{ subtitle }}
          </p>
        </div>
      </div>
    </div>

    <template #actions="{ onClose }">
      <v-spacer />

      <v-btn color="" @click="onClose()">{{ t('ok') }}</v-btn>
    </template>
  </sovi-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const model = defineModel<boolean>();

const props = withDefaults(
  defineProps<{
    title: string;
    subtitle?: string;
    type?: 'success' | 'failure';
  }>(),
  {
    subtitle: '',
    type: 'success',
  },
);

const iconPath = computed(() => {
  return props.type === 'success'
    ? 'M14.1 27.2l7.1 7.2 16.7-16.8'
    : 'M14.1 14.1l23.8 23.8 m0,-23.8 l-23.8,23.8';
});
</script>

<style lang="scss">
.sovi-status-dialog {
  &__wrapper {
    --checkmark-size: 64px;
    --checkmark-color: var(--color-green-500);

    &.failure {
      --checkmark-color: var(--color-red-500);
    }

    .checkmark__circle {
      stroke-dasharray: 166;
      stroke-dashoffset: 166;
      stroke-width: 2;
      stroke-miterlimit: 10;
      stroke: var(--checkmark-color);
      fill: none;
      animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }

    .checkmark {
      width: var(--checkmark-size);
      height: var(--checkmark-size);
      border-radius: 50%;
      display: block;
      stroke-width: 2;
      stroke: #fff;
      stroke-miterlimit: 10;
      // margin: 16px auto;
      box-shadow: inset 0px 0px 0px var(--checkmark-color);
      animation:
        fill 0.4s ease-in-out 0.4s forwards,
        scale 0.3s ease-in-out 0.45s both;
    }

    .checkmark__check {
      transform-origin: 50% 50%;
      stroke-dasharray: 48;
      stroke-dashoffset: 48;
      animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.4s forwards;
    }
  }
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}

@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px calc(var(--checkmark-size) / 2)
      var(--checkmark-color);
  }
}
</style>

<i18n lang="json">
{
  "fi": {
    "ok": "Ok"
  },
  "en": {
    "ok": "Ok"
  }
}
</i18n>
